module.exports = __webpack_public_path__ + "img/ic-grabpay.0477d5b4.png";